import { Card } from "~/features/configurator/Linear/components/Card";
import { styled } from "~/common/mui";

export const FCCTileCard = styled(Card)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(2),
  background: theme.palette.common.white,
  position: "relative",
  [theme.breakpoints.up("desktop-s")]: {
    padding: theme.spacing(3),
  },
}));

export const FCCTileTitle = styled("div")(({ theme }) => ({
  ...theme.typography.titleLarge,
}));

export const FCCTileSubtitle = styled("div")(({ theme }) => ({
  ...theme.typography.bodyMedium,
  color: theme.palette.text.secondary,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const FCCTileContent = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(1),
  [theme.breakpoints.up("desktop-s")]: {
    marginTop: theme.spacing(2),
  },
}));

export const FCCTileInfoIcon = styled("div")(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(3),
  top: theme.spacing(3),
}));

export const FCCTileTooltipContent = styled("div")(({ theme }) => ({
  width: 282,
  whiteSpace: "pre-line",
  padding: theme.spacing(1),
}));
